import { Component, OnInit, OnDestroy, Inject, ViewChild, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms"; import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core";
;
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import * as moment from "moment";
import { ConfirmEntityDialogComponent, LayoutUtilsService, LoaderService, RequestService, SmartMapComponent } from "src/app/shared";
import { SignalingService } from "src/app/shared/services/signaling.service";
import { CaseService } from "src/app/shared/services/case.service";
import { Observable, Subscription, debounceTime, from, map, startWith, switchMap } from "rxjs";
// import { AudionNoteDialogComponent } from "../../audio-note-dialog/audio-note-dialog.component";
// import { LabelExtractorDialogComponent } from "../../label-extractor-dialog/label-extractor-dialog.component";
import { MaterialManageDialogComponent } from "../../material-page/material-manage-dialog/material-manage-dialog.component";
import { ThreatDispatchDialogComponent } from "src/app/shared/components/threat-detection-dialog/dispatch-dialog/dispatch-dialog.component";

interface DialogData {
    caseId: string;
    note?: any;
    metadata: any;
    type?: any;
    title: string;
    geolocation: string;
    hideVoice?: boolean;
    view?: boolean;
    subType?: string;
    noteTypes?: string[];
}

enum TypesEnum {
    VIDEO = 'Video',
    AUDIO = 'Audio',
    IMAGE = 'Image',
    FILE = 'File',
    CAMERA = 'Camera',
};

export enum NoteTypesEnum {
    note = 'Note',
    carOfInterest = 'Car of Interest',
    personOfInterest = 'Person of Interest',
    LPR = 'LPR',
    annotation = 'Annotation',
    location = 'Go to Location',
    init = 'Note',
    material = 'Material',
    chat = 'Chat',
    case = 'Case',
    call = 'Call',
    missedcall = 'Missed Call',
    status = 'Status',
    threat = 'Incident',
    whiteboard = 'Whiteboard',
};

export const MY_DATE_FORMATS = {
    parse: {
        dateInput: 'YYYY-MM-DD',
    },
    display: {
        dateInput: 'YYYY-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY MMMM',
    },
};

@Component({
    selector: 'app-add-timeline-dialog',
    templateUrl: './add-timeline-dialog.component.html',
    styleUrls: ['./add-timeline-dialog.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
    ],
})

export class AddTimelineDialogComponent implements OnInit, OnDestroy, AfterViewInit {

    protected subscriptions: Subscription[] = [];
    public apiCallSubscription: any = undefined;
    public selectedUser: any;
    public isAdmin: boolean = false;
    public isSuperAdmin: boolean = false;
    public isInvestigator: boolean = false;
    public title: string = undefined;
    public description: string = undefined;
    public type: string = 'note';
    public form: FormGroup;
    public metadata = new Map();
    public titleDisplayName: string = undefined;
    public docs: any = [];
    public cameras: any = [];
    public currentUserMap: any = undefined;
    public noteLocation: string = undefined;
    public caseGeolocation: string = undefined;
    public investigators: any = [];
    public investigatorGroups: any = [];
    public uploadFileLabelDisplayName: string = undefined;
    public filteredPlates: any = [];
    public filteredCarMakes: any = [];
    public filteredCarModels: any = [];
    public threatTypes: any = [];
    public filteredPeople: any = [];
    public noteTypesEnumList: any[] = [
        { value: 'note', label: NoteTypesEnum.note },
        { value: 'carOfInterest', label: NoteTypesEnum.carOfInterest },
        { value: 'personOfInterest', label: NoteTypesEnum.personOfInterest },
        { value: 'LPR', label: NoteTypesEnum.LPR },
        { value: 'annotation', label: NoteTypesEnum.annotation },
        { value: 'location', label: NoteTypesEnum.location },
        { value: 'init', label: NoteTypesEnum.init },
        { value: 'material', label: NoteTypesEnum.material },
        { value: 'chat', label: NoteTypesEnum.chat },
        { value: 'case', label: NoteTypesEnum.case },
        { value: 'call', label: NoteTypesEnum.call },
        { value: 'missedcall', label: NoteTypesEnum.missedcall },
        { value: 'status', label: NoteTypesEnum.status },
        { value: 'threat', label: NoteTypesEnum.threat },
    ];
    public mainNoteType: string = 'note';
    public organizationId: string = undefined;

    private isCarOptionSelected = false;
    private isCarMakeOptionSelected = false;
    private isCarModelOptionSelected = false;
    private isPersonOptionSelected = false;
    titleDisplayNameMap = {
        audio: 'Audio',
        image: 'Image',
        file: 'File',
        video: 'Video',
        camera: 'Camera'
    };
    getFormControlName(type: string): string {
        return type + 'Control'; // e.g., 'audioControl', 'fileControl'
    }
    @ViewChild('timelineMap') timelineMap: SmartMapComponent;

    constructor(public dialogRef: MatDialogRef<AddTimelineDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private loader: LoaderService, private requestService: RequestService, private translate: TranslateService, private layoutUtilsService: LayoutUtilsService, private formBuilder: FormBuilder, private dialog: MatDialog, private signalingService: SignalingService, private caseService: CaseService,
        @Inject(MAT_DATE_LOCALE) public _locale: string, private _adapter: DateAdapter<any>) {
        if (localStorage.getItem('languageSelected')) {
            this._locale = localStorage.getItem('languageSelected');
        } else {
            this._locale = 'en';
        }
        this._adapter.setLocale(this._locale);
        if (this.data.noteTypes) {
            let noteTypesEnumList = [];
            this.data.noteTypes.forEach(type => {
                noteTypesEnumList.push({ value: type, label: NoteTypesEnum[type] });
            });
            this.noteTypesEnumList = noteTypesEnumList;
        }
        this.mainNoteType = this.data.type || 'note';
        if (this.data.type && this.data.type == 'note') {
            this.mainNoteType = 'note';
            if (this.data.subType == 'carOfInterest') {
                this.mainNoteType = 'carOfInterest';
            }
            else if (this.data.subType == 'personOfInterest') {
                this.mainNoteType = 'personOfInterest';
            }
        }
    }

    ngOnInit() {
        this.subscriptions.push(
            this.requestService.currentUserSubject.subscribe((data) => {
                if (data) {
                    this.selectedUser = data;
                    this.isAdmin = this.requestService.isUserRoleAdmin();
                    this.isSuperAdmin = this.requestService.isUserRoleSuperAdmin();
                    this.isInvestigator = this.requestService.isUserRoleInvestigator();
                    this.buildSetting();
                }
            })
        );

        this.subscriptions.push(this.requestService.pageOrganization.subscribe((data) => {
            if (data) {
                this.organizationId = data._id;
            }
        }));
    }
    buildSetting() {
        if (this.data.metadata) {
            this.threatTypes = this.data.metadata.fields.find(field => field.name == 'threat_types')?.enum || [];
            this.buildForm();
        }
        else {
            this.loader.display(true);
            this.caseService.getNoteMetadata().then((metadata: any) => {
                this.loader.display(false);
                if (metadata) {
                    this.data['metadata'] = metadata;
                    this.threatTypes = metadata.fields.find(field => field.name == 'threat_types')?.enum || [];
                    this.buildForm();
                }
            });
        }
    }
    buildForm() {
        let investigators = [];
        if (this.data.note?.investigators?.length) {
            this.data.note?.investigators.forEach(i => {
                investigators.push(i._id);
            });
        }

        let investigatorGroups = [];
        if (this.data.note?.investigatorgroup?.length) {
            this.data.note?.investigatorgroup.forEach(i => {
                investigatorGroups.push(i._id);
            });
        }

        if (this.data.note?.type) {
            this.mainNoteType = this.data.note.type;
            if (this.mainNoteType == 'note') {
                if (this.data.note.car_of_interest) {
                    this.mainNoteType = 'carOfInterest';
                    this.data.subType = 'carOfInterest';
                } else if (this.data.note.person_of_interest) {
                    this.mainNoteType = 'personOfInterest';
                    this.data.subType = 'personOfInterest';
                }
            }
        }
        const shouldDisableNoteType = this.noteTypesEnumList.length < 2 || this.data.note?._id ? true : false;
        let address = this.requestService.lang == 'ja' && this.data.note?.address_jp ? this.data.note?.address_jp : this.data.note?.address || '';
        address = address || this.data.note?.location || '';
        this.form = this.formBuilder.group({
            noteType: [{ value: this.mainNoteType || 'note', disabled: shouldDisableNoteType }, Validators.required],
            title: [this.data.note?.name || '', Validators.required],
            description: [this.data.note?.notes || ''],
            // selectedType: [this.data.note?.document?.type || ''],
            // selectedTypes: [[]],
            // audioControl: [[]],
            // imageControl: [[]],
            // fileControl: [[]],
            // videoControl: [[]],
            // document: [''],
            documents: [{ value: [], disabled: true }],
            cameras: [[]],
            // camera: [''],
            address: [address],
            actionDate: [''],
            actionTime: [''],
            // interest: [this.data.subType ? 'personOfInterest' : this.data.subType ? 'carOfInterest' : ''],
            personOfInterestName: [this.data.note?.person_of_interest_name || ''],
            personOfInterestDescription: [this.data.note?.person_of_interest_description || ''],
            personOfInterestDOB: [this.data.note?.person_of_interest_dob ? moment(this.data.note.person_of_interest_dob).format('YYYY-MM-DD') : ''],
            personOfInterestApproximateAge: [this.data.note?.person_of_interest_approximate_age || ''],
            personOfInterestHairColor: [this.data.note?.person_of_interest_hair_color || ''],
            personOfInterestHeight: [this.data.note?.person_of_interest_height || ''],
            personOfInterestDistinguishingFeatures: [this.data.note?.person_of_interest_distinguishing_features || ''],
            personOfInterestWeight: [this.data.note?.person_of_interest_weight || ''],
            personOfInterestEyeColor: [this.data.note?.person_of_interest_eye_color || ''],
            personOfInterestRace: [this.data.note?.person_of_interest_race || ''],
            plateOfInterest: [this.data.note?.plate_of_interest || ''],
            plateOfInterestDescription: [this.data.note?.car_of_interest_description || ''],
            plateOfInterestIdentifier: [this.data.note?.car_of_interest_identifier || ''],
            carColor: [this.data.note?.car_color || ''],
            investigators: [investigators],
            investigatorGroups: [investigatorGroups],
            carType: [this.data.note?.car_type || ''],
            carModel: [this.data.note?.car_model || ''],
            carMake: [this.data.note?.car_make || ''],
            personOfInterestGender: [this.data.note?.person_of_interest_gender || ''],
            personOfInterestGenderOther: [this.data.note?.person_of_interest_gender_other || ''],
            threat_type: [this.data.note?.threat_type || ''],
            threat_types: [this.getInitialThreatTypesFromNote()],
            excludeFromMap: [!!this.data.note?.excludeFromMap],
            alertSentTo: [this.data.note?.alertSentTo || ''],
        });

        this.subscriptions.push(this.form.controls.plateOfInterest.valueChanges.subscribe((data) => {
            if (localStorage.getItem('languageSelected') == 'ja') {
                this.enforceKatakana(data);
            }
            else {
                if (data) {
                    this.form.controls.plateOfInterest.setValue(data.toUpperCase(), { emitEvent: false });
                }
            }
        }));

        // if (this.data.subType == 'carOfInterest') {
        //     this.form.controls['car_of_interest_identifier'].setValidators([Validators.required]);
        //     this.searchPlates(undefined)
        // }
        // else 
        if (this.data.subType == 'personOfInterest') {
            this.form.controls['personOfInterestName'].setValidators([Validators.required]);
            // this.searchPeople(undefined);
        }

        this.form.get('plateOfInterest').valueChanges.pipe(
            debounceTime(300),
        ).subscribe(value => {
            if (!this.isCarOptionSelected) {
                from(this._filterPlates(value || ''));
            }
            this.isCarOptionSelected = false;
        });

        this.form.get('personOfInterestName').valueChanges.pipe(
            debounceTime(300),
        ).subscribe(value => {
            if (!this.isPersonOptionSelected) {
                from(this._filterPeople(value || ''));
            }
            this.isPersonOptionSelected = false;
        });
        this.form.get('carMake').valueChanges.pipe(
            debounceTime(300),
        ).subscribe(value => {
            if (!this.isCarMakeOptionSelected) {
                from(this._filterCarMakes(value || ''));
            }
            this.isCarMakeOptionSelected = false;
        });
        this.form.get('carModel').valueChanges.pipe(
            debounceTime(300),
        ).subscribe(value => {
            if (!this.isCarModelOptionSelected) {
                from(this._filterCarModels(value || ''));
            }
            this.isCarModelOptionSelected = false;
        });

        this.form.get('personOfInterestDOB')?.valueChanges.subscribe((value: string) => {
            if (!value) {
                return;
            }
            const dob = moment(value, 'YYYY-MM-DD', true);
            if (!dob.isValid()) {
                return;
            }
            const referenceDate = this.form.controls.actionDate.value
                ? moment(this.form.controls.actionDate.value, 'YYYY-MM-DD', true)
                : moment();
            const age = referenceDate.diff(dob, 'years');
            if (!isNaN(age) && age >= 0) {
                this.form.controls.personOfInterestApproximateAge.setValue(age, { emitEvent: false });
            }
        });

        this.form.get('personOfInterestGender')?.valueChanges.subscribe((value: string) => {
            if (value !== 'other' && this.form.controls.personOfInterestGenderOther) {
                this.form.controls.personOfInterestGenderOther.setValue('', { emitEvent: false });
            }
        });

        this.form.get('cameras').valueChanges.subscribe((cameraIds: string[]) => {
            this.handleCameraSelectionForThreat(cameraIds);
        });

        if (this.data.note?.action_date) {
            this.form.controls.actionDate.setValue(moment(this.data.note.action_date).format('YYYY-MM-DD'));
            this.form.controls.actionTime.setValue(moment(this.data.note.action_date).format("HH:mm"));
        }

        this.noteLocation = this.data.note?.geolocation;

        // if (this.data.note?.document?.type) {
        //     this.form.controls.selectedType.setValue(this.data.note?.document.type);
        //     this.loadDocuments(this.data.note?.document.type);
        // }
        // else if (this.data.note?.camera?._id) {
        //     this.form.controls.selectedType.setValue('camera');
        //     this.form.controls['camera'].setValidators([Validators.required]);
        //     this.loadCameras(this.data.caseId);
        // }

        // if (this.data.note?.documents && this.data.note.documents.length) {
        //     let documents: any[] = this.data.note.documents.filter(itm => itm._id);
        //     if (documents.length) {
        //         const typesSet = new Set(documents.map(doc => doc.type));
        //         let docTypes = Array.from(typesSet);
        //         this.form.controls.selectedTypes.setValue(docTypes);
        //         if (docTypes.length > 0) {
        //             this.loadAllDocuments();
        //         }
        //     }
        // }
        // if (this.data.note?.cameras && this.data.note.cameras.length) {
        //     let cameras: any[] = this.data.note.cameras.filter(itm => itm._id);
        //     if (cameras.length) {
        //         let valueList = this.form.controls.selectedTypes.value || [];
        //         valueList.push('camera')
        //         this.form.controls.selectedTypes.setValue(valueList);
        //         this.form.controls['cameras'].setValidators([Validators.required]);
        //         this.loadCameras(this.data.caseId);
        //     }
        // }

        if (this.data.note?.type == 'annotation') {
            // this.form.controls.selectedType.disable();
            // this.form.controls.selectedTypes.disable();
            // this.form.controls.audioControl.disable();
            // this.form.controls.imageControl.disable();
            // this.form.controls.fileControl.disable();
            // this.form.controls.videoControl.disable();
            // this.form.controls.document.disable();
            this.form.controls.documents.disable();
            this.form.controls.address.disable();
            this.loadAllDocuments();
        }
        else if (this.isReadOnlyTimelineNote()) {
            Object.keys(this.form.controls).forEach(controlName => {
                this.form.get(controlName).disable();
            });
        } else {

            this.loadAllDocuments();
            this.loadCameras(this.data.caseId);
        }

        this.data.metadata.fields.forEach((field: any) => {
            this.metadata.set(field.name, field);

            if (this.form.controls[field.name] && !this.metadata.get(field.name).nullable && field.name != 'camera' && field.name != 'cameras' && field.name != 'threat_type' && field.name != 'threat_types') {
                this.form.controls[field.name].setValidators([Validators.required]);
            }
        });
        this.applyThreatState();
        // this.titleMetadata = this.data.metadata.fields.find(i => i.name == 'name');
        // this.descriptionMetadata = this.data.metadata.fields.find(i => i.name == 'notes');
        // this.actionDateMetadata = this.data.metadata.fields.find(i => i.name == 'action_date');
        // this.interestMetadata = this.data.metadata.fields.find(i => i.name == 'interest');

        // if (!this.metadata.get('name').nullable) {
        //     this.form.controls['title'].setValidators([Validators.required]);
        // }

        // if (!this.metadata.get('notes').nullable) {
        //     this.form.controls['description'].setValidators([Validators.required]);
        // }

        // this.form.get('interest').valueChanges.subscribe((interest) => {
        //     if (interest == 'car') {
        //         this.getCarPlates();
        //         this.form.controls.personOfInterestName.setValue('');
        //         this.form.controls.personOfInterestDescription.setValue('');
        //         this.form.controls.personOfInterestGender.setValue('');
        //     }
        //     else {
        //         this.getPeople();
        //         this.form.controls.plateOfInterest.setValue('');
        //         this.form.controls.plateOfInterestIdentifier.setValue('');
        //         this.form.controls.plateOfInterestDescription.setValue('');
        //         this.form.controls.carColor.setValue('');
        //     }
        // });

        // if (this.form.controls.selectedType.value) {
        //     this.titleDisplayName = this.translate.instant(TypesEnum[this.form.controls.selectedType.value.toUpperCase()]);
        //     this.uploadFileLabelDisplayName = this.translate.instant("Add " + TypesEnum[this.form.controls.selectedType.value.toUpperCase()]);
        // }

        // this.form.get('selectedType').valueChanges.subscribe((type) => {
        //     if (type) {
        //         this.titleDisplayName = this.translate.instant(TypesEnum[type.toUpperCase()]);
        //         this.uploadFileLabelDisplayName = this.translate.instant("Add") + " " + this.translate.instant(TypesEnum[type.toUpperCase()]);
        //     }
        //     if (type != 'camera') {
        //         this.form.controls.camera.removeValidators([Validators.required]);
        //         this.form.controls.camera.setValue('');
        //         this.loadDocuments(type);
        //     }
        //     else {
        //         this.form.controls.camera.addValidators([Validators.required]);
        //         this.form.controls.document.setValue('');
        //         this.loadCameras(this.data.caseId);
        //     }
        // });
        //if (this.form.controls.selectedTypes.value) {
        // this.titleDisplayName = this.translate.instant(TypesEnum[this.form.controls.selectedType.value.toUpperCase()]);
        // this.uploadFileLabelDisplayName = this.translate.instant("Add " + TypesEnum[this.form.controls.selectedType.value.toUpperCase()]);
        //}
        // this.form.get('selectedTypes').valueChanges.subscribe((types) => {
        //     if ((!types.includes('camera') && types.length > 0) || (types.includes('camera') && types.length > 1)) {
        //         this.loadAllDocuments();
        //     } else {
        //         this.form.controls.audioControl.setValue([]);
        //         this.form.controls.imageControl.setValue([]);
        //         this.form.controls.fileControl.setValue([]);
        //         this.form.controls.videoControl.setValue([]);
        //     }
        //     if (types.includes('camera') && types.length > 0) {
        //         this.form.controls.cameras.addValidators([Validators.required]);
        //         this.loadCameras(this.data.caseId);
        //     } else {
        //         this.form.controls.cameras.removeValidators([Validators.required]);
        //         this.form.controls.cameras.setValue([]);
        //     }
        // });

        // this.form.get('address').valueChanges.subscribe((address) => {
        //     console.log('address', address)
        // });

        if (this.data && this.data.type) {
            this.type = this.data.type;

            // if (this.type == 'LPR') {
            //     // this.getCarPlates();
            // }
        }
        this.applyThreatState();

        this.investigators = this.caseService.investigators;
        this.investigatorGroups = this.caseService.investigatorGroups;

        if (!this.investigators.length && this.data.caseId) {
            this.caseService.getInvestigators(this.data.caseId).then((data: any) => {
                this.investigators = data.results;
            });
        }

        if (!this.investigatorGroups.length && this.data.caseId) {
            this.caseService.getInvestigatorGroups(this.data.caseId).then((data: any) => {
                this.investigatorGroups = data;
            });
        }
        if (!this.noteLocation && this.data.caseId) {
            this.caseService.getCase(this.data.caseId, true).then((data: any) => {
                if (data.geolocation) {
                    this.caseGeolocation = JSON.parse(data.geolocation);
                } else {
                    this.caseGeolocation = this.noteLocation;
                }
            });
        } else {
            this.caseGeolocation = this.noteLocation;
        }
    }
    onNoteTypeChange(value: string) {
        this.mainNoteType = value;
        if (value == 'carOfInterest') {
            this.data.subType = 'carOfInterest';
        } else if (value == 'personOfInterest') {
            this.data.subType = 'personOfInterest';
        } else if (value == 'threat') {
            this.data.subType = 'threat';
        } else {
            this.data.subType = '';
        }
        this.applyThreatState();
    }

    isReadOnlyTimelineNote(): boolean {
        return ['location', 'init', 'status', 'whiteboard'].includes(this.data.note?.type);
    }

    searchAddress() {
        if (this.isReadOnlyTimelineNote()) {
            return;
        }
        if (this.form.controls.address.value && this.form.controls.address.value !== '') {
            this.timelineMap.searchByText(this.form.controls.address.value);
        }
    }

    ngOnDestroy(): void {

    }

    ngAfterViewInit(): void {

    }

    save() {
        if (this.form.valid) {
            if (this.isThreatType() && !this.hasLocationAndAddress()) {
                this.layoutUtilsService.showNotification(this.translate.instant('Location and address are required.'), this.translate.instant('Dismiss'));
                return;
            }
            if ((this.data.subType == 'carOfInterest' || this.data.type == 'LPR') && !this.form.controls.plateOfInterest.value && !this.form.controls.plateOfInterestIdentifier.value) {
                this.layoutUtilsService.showNotification(this.translate.instant('Plate Number or Car Identifier should be filled.'), this.translate.instant('Dismiss'));
                return;
            }

            const dateMoment = moment(this.form.controls.actionDate.value, 'YYYY-MM-DD');
            const timeMoment = moment(this.form.controls.actionTime.value, 'HH:mm:ss');

            const actionDate = dateMoment.set({
                hour: timeMoment.hour(),
                minute: timeMoment.minute(),
                second: timeMoment.second(),
                millisecond: 0
            });

            let investigators = [];
            this.form.controls.investigators.value.forEach(i => {
                investigators.push({ _id: i, name: '' });
            });

            let investigatorGroups = [];
            this.form.controls.investigatorGroups.value.forEach(i => {
                investigatorGroups.push({ _id: i, name: '' });
            });

            if (this.data.subType == 'threat') {
                const selectedThreatDocumentIds = this.form.controls.documents.value || [];
                const selectedCameraId = this.form.controls.cameras.value[0] || undefined;
                const threatsMeta = selectedThreatDocumentIds.length > 0
                    ? selectedThreatDocumentIds.map(documentId => {
                        const selectedDoc = this.docs?.find(doc => doc._id == documentId);
                        return {
                            threat_type: this.form.controls.threat_type.value,
                            confidence: 1,
                            camera_id: selectedCameraId,
                            imagePath: selectedDoc?.url || "",
                            location: this.form.controls.address.value,
                            geolocation: this.noteLocation,
                            // camera_type: "",
                            source_type: "manual",
                            document_id: documentId,
                            name: this.form.get('title').value || '',
                            description: this.form.get('description').value || '',
                        };
                    })
                    : [{
                        threat_type: this.form.controls.threat_type.value,
                        confidence: 1,
                        camera_id: selectedCameraId,
                        imagePath: "",
                        location: this.form.controls.address.value,
                        geolocation: this.noteLocation,
                        // camera_type: "",
                        source_type: "manual",
                        document_id: "",
                        name: this.form.get('title').value || '',
                        description: this.form.get('description').value || '',
                    }];
                let objeData = {
                    name: this.form.get('title').value,
                    description: this.form.get('description').value,
                    geolocation: this.noteLocation,
                    location: this.form.controls.address.value,
                    excludeFromMap: !!this.form.controls.excludeFromMap?.value,
                    source_type: "manual",
                    camera_id: selectedCameraId, // update "camera_group_id", "camera_type" based on camera_id
                    // threat_type: this.form.controls.threat_type.value,

                    case: {
                        _id: this.data.caseId
                    },
                    threats_meta: threatsMeta,
                    // documents: this.getDocumentValues(),
                    // cameras: this.getCamerasValues(),
                    organizationId: { _id: this.organizationId },
                }
                this.openDispatch(objeData);
                // this.requestService.postRequest('threatsmeta', '', objeData, (data, error) => {
                //     if (data) {
                //         this.layoutUtilsService.showNotification(this.translate.instant('Created successfully'), this.translate.instant('Dismiss'));
                //         this.dialogRef.close({ data: data.results });
                //     }
                //     if (error) {
                //         this.layoutUtilsService.showNotification(this.translate.instant('An error has occurred. Please try again later.'), this.translate.instant('Dismiss'))
                //         this.dialogRef.close(undefined);
                //     }
                //     this.loader.display(false);
                // });
            } else {
                this.loader.display(true);
                let objeData = {
                    name: this.form.get('title').value,
                    notes: this.form.get('description').value,
                    type: this.getPayloadType(),
                    case: {
                        _id: this.data.caseId
                    },
                    documents: this.getDocumentValues(),
                    cameras: this.getCamerasValues(),
                    geolocation: this.noteLocation,
                    location: this.form.controls.address.value,
                    excludeFromMap: !!this.form.controls.excludeFromMap?.value,
                    action_date: actionDate.toISOString() || '',
                    person_of_interest_description: this.form.controls.personOfInterestDescription.value,
                    person_of_interest_name: this.form.controls.personOfInterestName.value,
                    person_of_interest_dob: this.form.controls.personOfInterestDOB.value
                        ? moment(this.form.controls.personOfInterestDOB.value, 'YYYY-MM-DD').toISOString()
                        : undefined,
                    person_of_interest_approximate_age: this.form.controls.personOfInterestApproximateAge.value,
                    person_of_interest_hair_color: this.form.controls.personOfInterestHairColor.value,
                    person_of_interest_height: this.form.controls.personOfInterestHeight.value,
                    person_of_interest_distinguishing_features: this.form.controls.personOfInterestDistinguishingFeatures.value,
                    person_of_interest_weight: this.form.controls.personOfInterestWeight.value,
                    person_of_interest_eye_color: this.form.controls.personOfInterestEyeColor.value,
                    person_of_interest_race: this.form.controls.personOfInterestRace.value,
                    plate_of_interest: this.form.controls.plateOfInterest.value,
                    car_of_interest_description: this.form.controls.plateOfInterestDescription.value,
                    car_of_interest_identifier: this.form.controls.plateOfInterestIdentifier.value,
                    car_color: this.form.controls.carColor.value,
                    car_of_interest: this.data.subType == 'carOfInterest' ? true : false,
                    person_of_interest: this.data.subType == 'personOfInterest' ? true : false,
                    investigators: investigators,
                    investigatorgroup: investigatorGroups,
                    car_make: this.form.controls.carMake.value,
                    car_model: this.form.controls.carModel.value,
                    car_type: this.form.controls.carType.value,
                    person_of_interest_gender: this.form.controls.personOfInterestGender.value,
                    person_of_interest_gender_other: this.form.controls.personOfInterestGenderOther.value,
                }
                this.requestService.postRequest('note', '', objeData, (data, error) => {
                    if (data) {
                        this.layoutUtilsService.showNotification(this.translate.instant('Created successfully'), this.translate.instant('Dismiss'));
                        this.dialogRef.close({ data: data.results });
                    }
                    if (error) {
                        this.layoutUtilsService.showNotification(this.translate.instant('An error has occurred. Please try again later.'), this.translate.instant('Dismiss'))
                        this.dialogRef.close(undefined);
                    }
                    this.loader.display(false);
                });
            }
        }
    }
    getDocumentValues(preData: any[] = []) {
        let dataList = preData;
        if (this.form.controls.documents.value && this.form.controls.documents.value.length > 0) {
            for (let itm of this.form.controls.documents.value) {
                dataList.push({
                    _id: itm
                })
            }
        }
        // if (this.form.controls.audioControl.value && this.form.controls.audioControl.value.length > 0) {
        //     for (let itm of this.form.controls.audioControl.value) {
        //         dataList.push({
        //             _id: itm
        //         })
        //     }
        // }
        // if (this.form.controls.imageControl.value && this.form.controls.imageControl.value.length > 0) {
        //     for (let itm of this.form.controls.imageControl.value) {
        //         dataList.push({
        //             _id: itm
        //         })
        //     }
        // }
        // if (this.form.controls.fileControl.value && this.form.controls.fileControl.value.length > 0) {
        //     for (let itm of this.form.controls.fileControl.value) {
        //         dataList.push({
        //             _id: itm
        //         })
        //     }
        // }
        // if (this.form.controls.videoControl.value && this.form.controls.videoControl.value.length > 0) {
        //     for (let itm of this.form.controls.videoControl.value) {
        //         dataList.push({
        //             _id: itm
        //         })
        //     }
        // }
        return dataList;
    }
    getCamerasValues(preData: any[] = []) {
        let dataList = preData;
        if (this.form.controls.cameras.value && this.form.controls.cameras.value.length > 0) {
            for (let itm of this.form.controls.cameras.value) {
                dataList.push({
                    _id: itm
                })
            }
        }
        return dataList;
    }
    update() {
        if (this.form.valid) {
            if (this.isThreatType() && !this.hasLocationAndAddress()) {
                this.layoutUtilsService.showNotification(this.translate.instant('Location and address are required.'), this.translate.instant('Dismiss'));
                return;
            }
            if ((this.data.subType == 'carOfInterest' || this.data.type == 'LPR') && !this.form.controls.plateOfInterest.value && !this.form.controls.plateOfInterestIdentifier.value) {
                this.layoutUtilsService.showNotification(this.translate.instant('Plate Number or Car Identifier should be filled.'), this.translate.instant('Dismiss'));
                return;
            }

            const dateMoment = moment(this.form.controls.actionDate.value, 'YYYY-MM-DD');
            const timeMoment = moment(this.form.controls.actionTime.value, 'HH:mm:ss');

            const actionDate = dateMoment.set({
                hour: timeMoment.hour(),
                minute: timeMoment.minute(),
                second: timeMoment.second(),
                millisecond: 0
            });

            let investigators = [];
            this.form.controls.investigators.value.forEach(i => {
                investigators.push({ _id: i, name: '' });
            });

            let investigatorGroups = [];
            this.form.controls.investigatorGroups.value.forEach(i => {
                investigatorGroups.push({ _id: i, name: '' });
            });

            // console.log(this.form.controls.camera.value);
            // console.log(this.form.controls.document.value);

            this.loader.display(true);
            this.requestService.postRequest('note', this.data.note._id, {
                name: this.form.get('title').value,
                notes: this.form.get('description').value,
                type: this.getPayloadType(),
                case: {
                    _id: this.data.note.case._id,
                    name: this.data.note.case.name,
                },
                // document: {
                //     _id: this.form.controls.document.value
                // },
                documents: this.getDocumentValues(),
                cameras: this.getCamerasValues(),
                // camera: {
                //     _id: this.form.controls.camera.value,
                // },
                // geolocation: this.form.controls.camera.value && this.cameras.find(i => i._id == this.form.controls.camera.value)?.geolocation ? this.cameras.find(i => i._id == this.form.controls.camera.value)?.geolocation : this.noteLocation,
                geolocation: this.noteLocation,
                // geolocation: this.form.controls.selectedType.value != 'camera' ? this.noteLocation : '',
                location: this.form.controls.address.value ? this.form.controls.address.value : '',
                action_date: actionDate.toISOString() || '',
                person_of_interest_description: this.form.controls.personOfInterestDescription.value,
                person_of_interest_name: this.form.controls.personOfInterestName.value,
                person_of_interest_dob: this.form.controls.personOfInterestDOB.value
                    ? moment(this.form.controls.personOfInterestDOB.value, 'YYYY-MM-DD').toISOString()
                    : undefined,
                person_of_interest_approximate_age: this.form.controls.personOfInterestApproximateAge.value,
                person_of_interest_hair_color: this.form.controls.personOfInterestHairColor.value,
                person_of_interest_height: this.form.controls.personOfInterestHeight.value,
                person_of_interest_distinguishing_features: this.form.controls.personOfInterestDistinguishingFeatures.value,
                person_of_interest_weight: this.form.controls.personOfInterestWeight.value,
                person_of_interest_eye_color: this.form.controls.personOfInterestEyeColor.value,
                person_of_interest_race: this.form.controls.personOfInterestRace.value,
                plate_of_interest: this.form.controls.plateOfInterest.value,
                car_of_interest_description: this.form.controls.plateOfInterestDescription.value,
                car_of_interest_identifier: this.form.controls.plateOfInterestIdentifier.value,
                car_color: this.form.controls.carColor.value,
                car_of_interest: this.data.subType == 'carOfInterest' ? true : false,
                person_of_interest: this.data.subType == 'personOfInterest' ? true : false,
                investigators: investigators,
                investigatorgroup: investigatorGroups,
                car_make: this.form.controls.carMake.value,
                car_model: this.form.controls.carModel.value,
                car_type: this.form.controls.carType.value,
                person_of_interest_gender: this.form.controls.personOfInterestGender.value,
                person_of_interest_gender_other: this.form.controls.personOfInterestGenderOther.value,
                excludeFromMap: !!this.form.controls.excludeFromMap?.value,
                ...(this.getPayloadType() === 'threat' && this.data.note?._id
                    ? { threat_types: this.form.controls.threat_types?.value ?? [] }
                    : {}),
            }, (data, error) => {
                if (data) {
                    this.layoutUtilsService.showNotification(this.translate.instant('updated successfully'), this.translate.instant('Dismiss'));
                    this.caseService.noteChangedSubject.next(true);
                    this.dialogRef.close({ data: data.results });
                }
                if (error) {
                    this.layoutUtilsService.showNotification(this.translate.instant('An error has occurred. Please try again later.'), this.translate.instant('Dismiss'));
                    this.dialogRef.close(undefined);
                }
                this.loader.display(false);
            });
        }
    }

    delete() {
        if (this.data.note.type != 'init' && this.data.note.type != 'status' && this.data.note.type != 'location') {
            const dialog = this.dialog.open(ConfirmEntityDialogComponent, {
                autoFocus: false,
                data: {
                    description: this.translate.instant(
                        'Are you sure you want to delete this note?'
                    ),
                    confirmbtn: this.translate.instant('Delete'),
                    cancelbtn: this.translate.instant('Cancel')
                },
                width: 'fit-content',
            });
            dialog.afterClosed().subscribe((result) => {
                if (result) {
                    this.loader.display(true);
                    this.requestService.postRequest('note', this.data.note._id + '/delete', {}, (data, error) => {
                        if (data) {
                            this.layoutUtilsService.showNotification(this.translate.instant('Deleted successfully'), this.translate.instant('Dismiss'));
                            this.dialogRef.close({ data: undefined });
                        }
                        if (error) {
                            this.layoutUtilsService.showNotification(this.translate.instant('An error has occurred. Please try again later.'), this.translate.instant('Dismiss'));
                            this.dialogRef.close(undefined);
                        }
                        this.loader.display(false);
                    });
                }
            });
        }
    }

    // private loadDocuments(type: string) {
    //     this.loader.display(true);
    //     this.loadDocumentsPromise(type).then((data: any) => {
    //         this.docs = data.results;
    //         if (this.data.note?.document._id)
    //             this.form.controls.document.setValue(this.data.note?.document._id);
    //     }).finally(() => {
    //         this.loader.display(false);
    //     })
    // }
    private loadAllDocuments() {
        this.loader.display(true);
        this.loadDocumentsPromise(undefined).then((data: any) => {
            this.docs = data.results;
            if (this.data.note?.documents) {
                let dataAdioList = this.getIdList(this.data.note?.documents);
                this.form.controls.documents.setValue(dataAdioList);
                // let dataAdioList = this.getIdListByType(this.data.note?.documents, 'audio');
                // let dataImageList = this.getIdListByType(this.data.note?.documents, 'image');
                // let dataFileList = this.getIdListByType(this.data.note?.documents, 'file');
                // let dataVideoList = this.getIdListByType(this.data.note?.documents, 'video');
                // this.form.controls.audioControl.setValue(dataAdioList);
                // this.form.controls.imageControl.setValue(dataImageList);
                // this.form.controls.fileControl.setValue(dataFileList);
                // this.form.controls.videoControl.setValue(dataVideoList);
            }
        }).finally(() => {
            this.loader.display(false);
        })
    }
    getIdListByType(listData, type) {
        let dataList = [];
        if (listData) {
            for (let itm of listData) {
                if (itm.type == type) {
                    dataList.push(itm._id);
                }
            }
        }
        return dataList;
    }
    getIdList(listData) {
        let dataList = [];
        if (listData) {
            for (let itm of listData) {
                dataList.push(itm._id);
            }
        }
        return dataList;
    }
    private loadCamerasOld(caseId: string) {
        this.loader.display(true);
        this.loadCamerasPromise(caseId).then((cameras: any) => {
            this.cameras = cameras.results || [];
            if (this.data.note?.camera._id)
                this.form.controls.camera.setValue(this.data.note?.camera._id);
        }).finally(() => {
            this.loader.display(false);
        })
    }
    private async loadCameras(caseId: string) {
        this.loader.display(true);
        let camerasData = [];
        let dataCamPromise = this.loadCamerasPromise(caseId).then((data: any) => {
            let dataResult = [];
            if (data.results) {
                dataResult = data.results;
            }
            camerasData = dataResult;
        });
        let currentUsermapData = undefined;
        let currentUsermapPromise: Promise<void> = Promise.resolve(undefined);
        if (this.isInvestigator) {
            currentUsermapPromise = this.getInvestigatorCaseData(caseId, this.selectedUser._id).then((data: any) => {
                let dataResult = [];
                if (data.results && data.results.length > 0) {
                    dataResult = data.results[0];
                }
                currentUsermapData = dataResult;
            });
        }

        await Promise.all([dataCamPromise, currentUsermapPromise]).then(_ => { }).catch(e => {
            this.layoutUtilsService.showNotification(this.translate.instant('Error: ') + e, this.translate.instant('Dismiss'));
        }).finally(() => {
            let cameras = camerasData || []
            if (this.isInvestigator) {
                let currentUserMap = currentUsermapData;
                this.currentUserMap = currentUsermapData;
                if (!currentUserMap || !currentUserMap.timeline_visibility || currentUserMap.timeline_visibility === '' || currentUserMap.timeline_visibility === 'filtered') {
                    let selectedCamerasId = this.getIdList(this.data?.note?.cameras);
                    cameras = cameras.filter((itm) => {
                        if (!itm.invisible) {
                            return true;
                        } else {
                            if (selectedCamerasId.includes(itm._id)) {
                                return true;
                            }
                        }
                        return false;
                    }
                    );
                }
            }

            this.cameras = cameras || [];
            if (this.data?.note?.cameras && this.data?.note?.cameras.length > 0) {
                let selectedCamerasId = this.getIdList(this.data?.note?.cameras);
                let cams = this.cameras.filter(i => selectedCamerasId.includes(i._id));
                cams = this.getIdList(cams);
                if (cams && cams.length > 0) {
                    const threatCreate =
                        this.data.subType === 'threat' && !this.data.note?._id;
                    this.form.controls.cameras.setValue(
                        threatCreate && cams.length > 1 ? [cams[0]] : cams,
                        { emitEvent: !this.data.note?._id }
                    );
                }
            }
            this.loader.display(false);
        });
    }
    private loadCamerasPromise(caseId: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.requestService.getRecord('', `case/camera/${caseId}/all`, (data, error) => {
                if (error) {
                    reject(error);
                }
                if (data) {
                    resolve(data);
                }
            });
        });
    }
    getInvestigatorCaseData(caseId, userId): Promise<void> {
        return new Promise((resolve, reject) => {
            this.requestService.getRecord('', `case/caseusermapping/${caseId}/list/${userId}`, (data, error) => {
                if (error) {
                    reject(error);
                }
                if (data) {
                    resolve(data);
                }
            });
        });
    }
    private loadDocumentsPromise(type: string): Promise<void> {
        return new Promise((resolve, reject) => {
            let andFilter: any = [
                { "organizationId._id": { "$in": [this.requestService.orgId] } },
                // { "type": { "$eq": type } },
            ];

            if (this.data.caseId) {
                andFilter.push(
                    { "case._id": { "$eq": this.data.caseId } }
                )
            }

            this.requestService.postRequest('doc', 'search', {
                order: [{ "field": "createdAt", "order": "desc" }],
                fields: ["createdAt", "name", "case", "type", "url"],
                term: "",
                filter: {
                    "$and": andFilter
                }
            }, (data, error) => {
                if (error) {
                    reject(error);
                }
                if (data) {
                    resolve(data);
                }
            });
        });
    }

    markerMapSelect(mark: any) {
        if (this.isReadOnlyTimelineNote()) {
            return;
        }
        if (this.data.note?.type != 'annotation' && this.data.note?.type != 'location' && this.data.note?.type != 'whiteboard')
            this.noteLocation = JSON.stringify(mark);
    }

    addressPinData(address: any) {
        if (this.isReadOnlyTimelineNote()) {
            return;
        }
        if (this.requestService.lang == 'en') {
            if (this.data.note?.type != 'annotation' && this.data.note?.type != 'location')
                this.form.controls.address.setValue(address);
        }

    }
    addressJPPinData(address: any) {
        if (this.isReadOnlyTimelineNote()) {
            return;
        }
        if (this.requestService.lang == 'ja') {
            if (this.data.note?.type != 'annotation' && this.data.note?.type != 'location')
                this.form.controls.address.setValue(address);
        }
    }
    manageAttachments() {
        if (this.isReadOnlyTimelineNote()) {
            return;
        }
        const documentsList = JSON.parse(JSON.stringify(this.form.controls.documents.value || []));
        const dialogRef = this.dialog.open(MaterialManageDialogComponent, {
            autoFocus: false,
            width: '80vw',
            disableClose: true,
            data: {
                caseId: this.data.caseId,
                selectedFiles: documentsList,
                type: this.type == 'threat' ? 'image' : undefined,
                metadata: this.data.metadata,
                ai_flag: this.data.subType
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.loader.display(true);
            this.loadDocumentsPromise(undefined).then((data: any) => {
                this.docs = data.results;
                // if (type == 'audio') {
                if (result) {
                    let itms = result || [];
                    this.form.controls.documents.setValue(itms);
                }
            }).finally(() => {
                this.loader.display(false);
            })
        });
    }
    getDocsByType(type: string) {
        return this.docs.filter(doc => doc.type === type);
    }
    // getPeople() {
    //     this.loader.display(true);
    //     this.caseService.getPeople().then(people => {
    //         this.people = people;
    //     }).catch(e => {
    //         this.layoutUtilsService.showNotification(this.translate.instant('An error has occurred. Please try again later.'), this.translate.instant('Dismiss'));
    //         this.loader.display(false);
    //     }).finally(() => {
    //         this.loader.display(false);
    //     })
    // }

    // getCarPlates() {
    //     this.loader.display(true);
    //     this.caseService.getCarPlates().then(plates => {
    //         this.plates = plates;
    //     }).catch(e => {
    //         this.layoutUtilsService.showNotification(this.translate.instant('An error has occurred. Please try again later.'), this.translate.instant('Dismiss'));
    //         this.loader.display(false);
    //     }).finally(() => {
    //         this.loader.display(false);
    //     })
    // }

    private async _filterPlates(value: string) {
        // if (value != this.form.controls.plateOfInterest.value)
        if (value != "") {
            this.filteredPlates = await this.searchPlates(value);
        }
        else {
            this.filteredPlates = [];
        }
    }
    private async _filterCarMakes(value: string) {
        if (value != "") {
            this.filteredCarMakes = await this.searchCarMakes(value);
        }
        else {
            this.filteredCarMakes = [];
        }
    }
    private async _filterCarModels(value: string) {
        if (value != "") {
            this.filteredCarModels = await this.searchCarModels(value);
        }
        else {
            this.filteredCarModels = [];
        }
    }
    private searchCarModels(value: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.requestService.postRequest('note', 'carmodel/search', {
                order: [{ "field": "car_model", "order": "asc" }],
                fields: ["car_model"],
                term: value ? value.toLowerCase() : undefined,
                termfields: ["car_model"],
                filter: {
                    "$and": [{ "organizationId._id": { "$in": [this.requestService.orgId] } }],
                }
            }, (data, error) => {
                if (data?.results) {
                    resolve(data.results);
                }
                else
                    resolve();
            });
        });
    }
    private searchCarMakes(value: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.requestService.postRequest('note', 'carmake/search', {
                order: [{ "field": "car_make", "order": "asc" }],
                fields: ["car_make"],
                term: value ? value.toLowerCase() : undefined,
                termfields: ["car_make"],
                filter: {
                    "$and": [{ "organizationId._id": { "$in": [this.requestService.orgId] } }],
                }
            }, (data, error) => {
                if (data?.results) {
                    resolve(data.results);
                }
                else
                    resolve();
            });
        });
    }
    private searchPlates(value: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.requestService.postRequest('note', 'carplate/search', {
                order: [{ "field": "plate_of_interest", "order": "asc" }],
                fields: ["plate_of_interest"],
                term: value ? value.toLowerCase() : undefined,
                termfields: ["plate_of_interest"],
                filter: {
                    "$and": [{ "organizationId._id": { "$in": [this.requestService.orgId] } }],
                }
            }, (data, error) => {
                if (data?.results) {
                    resolve(data.results);
                }
                else
                    resolve();
            });
        });
    }

    private async _filterPeople(value: string) {
        if (value != "") {
            this.filteredPeople = await this.searchPeople(value.toLowerCase());
        }
        else {
            this.filteredPeople = [];
        }
    }

    private searchPeople(value: string): Promise<void> {
        return new Promise((resolve, reject) => {
            this.requestService.postRequest('note', 'persons/search', {
                order: [{ "field": "person_of_interest_name", "order": "asc" }],
                fields: ["person_of_interest_name"],
                term: value ? value.toLowerCase() : undefined,
                termfields: ["person_of_interest_name"],
                filter: {
                    "$and": [{ "organizationId._id": { "$in": [this.requestService.orgId] } }],
                }
            }, (data, error) => {
                if (data?.results) {
                    resolve(data.results);
                }
                else
                    resolve();
            });
        });
    }

    onPersonSelection(event: any) {
        this.isPersonOptionSelected = true;
        this.loader.display(true);
        this.requestService.postRequest('note', 'persons/get', {
            order: [{ field: "updatedAt", order: "desc" }],
            fields: ["createdAt", "person_of_interest_name", "person_of_interest_description", "person_of_interest_gender", "person_of_interest_hair_color", "person_of_interest_dob", "person_of_interest_approximate_age", "person_of_interest_height", "person_of_interest_weight", "person_of_interest_eye_color", "person_of_interest_race", "person_of_interest_distinguishing_features", "person_of_interest_gender_other"],
            term: '',
            termfields: ["person_of_interest_name"],
            filter: {
                "person_of_interest_name": event.option.value, "$and": [{ "organizationId._id": { "$in": [this.requestService.orgId] } }]
            }
        }, (data, error) => {
            if (data.results) {
                this.form.controls.personOfInterestDescription.setValue(data.results.person_of_interest_description);
                this.form.controls.personOfInterestGender.setValue(data.results.person_of_interest_gender);
                this.form.controls.personOfInterestHairColor.setValue(data.results.person_of_interest_hair_color);
                this.form.controls.personOfInterestDOB.setValue(data.results.person_of_interest_dob);
                this.form.controls.personOfInterestApproximateAge.setValue(data.results.person_of_interest_approximate_age);
                this.form.controls.personOfInterestHeight.setValue(data.results.person_of_interest_height);
                this.form.controls.personOfInterestWeight.setValue(data.results.person_of_interest_weight);
                this.form.controls.personOfInterestEyeColor.setValue(data.results.person_of_interest_eye_color);
                this.form.controls.personOfInterestRace.setValue(data.results.person_of_interest_race);
                this.form.controls.personOfInterestDistinguishingFeatures.setValue(data.results.person_of_interest_distinguishing_features);
                this.form.controls.personOfInterestGenderOther.setValue(data.results.person_of_interest_gender_other);
            }
            this.loader.display(false);
        });
    }

    onCarSelection(event: any) {
        this.isCarOptionSelected = true;
        this.loader.display(true);
        this.requestService.postRequest('note', 'carplate/get', {
            order: [{ field: "updatedAt", order: "desc" }],
            fields: ["createdAt", "plate_of_interest", "car_of_interest_identifier", "car_of_interest_description", "car_color", "car_make", "car_model", "car_type"],
            term: '',
            termfields: ["plate_of_interest"],
            filter: {
                "plate_of_interest": event.option.value, "$and": [{ "organizationId._id": { "$in": [this.requestService.orgId] } }]
            }
        }, (data, error) => {
            if (data.results) {
                this.form.controls.plateOfInterestDescription.setValue(data.results.car_of_interest_description);
                this.form.controls.plateOfInterestIdentifier.setValue(data.results.car_of_interest_identifier);
                this.form.controls.carColor.setValue(data.results.car_color);
                this.form.controls.carMake.setValue(data.results.car_make);
                this.form.controls.carModel.setValue(data.results.car_model);
                this.form.controls.carType.setValue(data.results.car_type);
            }
            this.loader.display(false);
        });
    }
    onCarMakeSelection(event: any) {
        this.isCarMakeOptionSelected = true;
        this.form.controls.carMake.setValue(event.option.value);
    }
    onCarModelSelection(event: any) {
        this.isCarModelOptionSelected = true;
        this.form.controls.carModel.setValue(event.option.value);
    }
    private enforceKatakana(input: string): void {
        if (input) {
            // Replace any character not in Katakana range
            const filtered = input.replace(/[^\uFF61-\uFF9F0-9]+/g, '');
            if (filtered !== input) {
                // Update the input's value
                input = filtered;
                // Update the form control without re-triggering the input event
                this.form.controls.plateOfInterest.setValue(filtered, { emitEvent: false });
            }
        }
    }

    isDirty() {
        if (this.form.value && Object.values(this.form.value).some(val => val !== null && val !== '')) {
            return true;
        }
        return false;
    }

    // addAudioNote() {
    //     const dialog = this.dialog.open(AudionNoteDialogComponent, {
    //         disableClose: true,
    //         width: '40vw',
    //         data: {
    //             caseId: this.data.caseId,
    //         }
    //     });
    //     dialog.afterClosed().subscribe((captions) => {
    //         if (captions) {
    //             this.loader.display(true);

    //             // const body = {
    //             //     model: 'gpt-3.5-turbo',
    //             //     messages: [{
    //             //         role: 'system', content: `You are a label extractor assistant that reads police reports and returns structured data in strict JSON format. Always respond in the same language as the input and ONLY with valid JSON using the following keys:
    //             //         - case_location
    //             //         - reported_by
    //             //         - officer_name
    //             //         - action_date
    //             //         - action_time
    //             //         - vehicle_description 
    //             //         - vehicle_type 
    //             //         - vehicle_color 
    //             //         - vehicle_plate
    //             //         - vehicle_model 
    //             //         - vehicle_make
    //             //         - investigators (array of strings)
    //             //         - investigator_groups (array of strings)
    //             //         - material_type
    //             //         - material_name
    //             //         - person_name
    //             //         - person_gender
    //             //         - person_description
    //             //         - title
    //             //         - details (put everything else that was not captured from the mentioned labels)` }, {
    //             //         role: 'user',
    //             //         content: text
    //             //     }]
    //             // };
    //             this.requestService.postRequest('openai', 'extract/labels', {
    //                 text: captions,
    //                 content: `You are a label extractor assistant that reads police reports and returns structured data in strict JSON format. Always respond in the same language as the input and ONLY with valid JSON using the following keys:
    //                     - case_location
    //                     - reported_by
    //                     - officer_name
    //                     - action_date
    //                     - action_time
    //                     - vehicle_description
    //                     - vehicle_type
    //                     - vehicle_color
    //                     - vehicle_plate
    //                     - vehicle_model
    //                     - vehicle_make
    //                     - investigators (array of strings)
    //                     - investigator_groups (array of strings)
    //                     - material_type
    //                     - material_name
    //                     - person_name
    //                     - person_gender
    //                     - person_description
    //                     - title
    //                     - details (put everything else that was not captured from the mentioned labels)`
    //             }, (data, error) => {
    //                 if (data?.status) {
    //                     console.log('Response:', data.results);
    //                     // Handle the response here
    //                     let answers = data.results;
    //                     // console.log('answers', answers);

    //                     const dialog = this.dialog.open(LabelExtractorDialogComponent, {
    //                         disableClose: false,
    //                         data: {
    //                             caseId: this.data.caseId,
    //                             answers: answers,
    //                             // title: this.translate.instant('Add Note'),
    //                             // note: {
    //                             //     name: message,
    //                             //     document: {}
    //                             // },
    //                         }
    //                     });

    //                     // let answers: any = {
    //                     //     "action_date": "April 2025",
    //                     //     "action_time": "8:13 a.m.",
    //                     //     "vehicle_color": "red",
    //                     //     "vehicle_plate": "12345",
    //                     //     "vehicle_type": "car",
    //                     //     "vehicle_make": "Toyota",
    //                     //     "vehicle_model": "Corolla",
    //                     //     "vehicle_description": "Toyota Corolla 2023",
    //                     //     "investigators": [
    //                     //         "Korean interactive 1744",
    //                     //         "Korean interactive 1753",
    //                     //         "Korean interactive 1751",
    //                     //         "Cypher 1770",
    //                     //         "glee, Liam"
    //                     //     ],
    //                     //     "investigator_groups": [
    //                     //         "Co Group Tokyo 16"
    //                     //     ],
    //                     //     "person_gender": "male",
    //                     //     "material_type": "audio",
    //                     //     "material_name": "Audio one",
    //                     //     "summary": "this is a summary",
    //                     //     "details": "the weather was gloomy. I was with investigator Amir. Thank you."
    //                     // }

    //                     dialog.afterClosed().subscribe(data => {
    //                         if (data) {
    //                             // let profile = this.caseService.profile.getValue();
    //                             this.form.controls.description.setValue(answers.summary + '\n' + answers.details);
    //                             this.form.controls.title.setValue(answers.title);
    //                             this.form.controls.address.setValue(answers.case_location);
    //                             this.form.controls.carModel.setValue(answers.vehicle_model);
    //                             this.form.controls.plateOfInterestIdentifier.setValue(answers.vehicle_type);
    //                             this.form.controls.carMake.setValue(answers.vehicle_make);
    //                             this.form.controls.carColor.setValue(answers.vehicle_color);
    //                             // this.form.controls.actionDate.setValue(answers.action_date);
    //                             this.form.controls.actionTime.setValue(answers.action_time);

    //                             this.form.controls.actionDate.setValue(moment(answers.action_date).format('yyyy-MM-DD'));

    //                             this.form.controls.plateOfInterest.setValue(answers.vehicle_plate);
    //                             this.form.controls.personOfInterestName.setValue(answers.person_name);
    //                             this.form.controls.personOfInterestDescription.setValue(answers.person_description);
    //                             this.form.controls.plateOfInterestDescription.setValue(answers.vehicle_description);



    //                             // this.form.controls.selectedType.setValue(answers.material_type);

    //                             // this.form.controls.selectedTypes.setValue([answers.material_type]);



    //                             this.form.controls.personOfInterestGender.setValue(answers.person_gender);

    //                             if (answers.investigators?.length) {
    //                                 answers.investigators.forEach(inv => {
    //                                     let findInv = this.investigators.find(i => i.alternative_name == inv || i.name == inv);
    //                                     if (findInv) {
    //                                         this.form.controls.investigators.setValue(this.form.controls.investigators.getRawValue().push(findInv._id));
    //                                     }
    //                                 });
    //                             }

    //                             if (answers.investigator_groups?.length) {
    //                                 answers.investigator_groups.forEach(gr => {
    //                                     let findGroup = this.investigatorGroups.find(i => i.name == gr);
    //                                     if (findGroup) {
    //                                         this.form.controls.investigatorGroups.setValue(this.form.controls.investigatorGroups.getRawValue().push(findGroup._id));
    //                                     }
    //                                 });
    //                             }

    //                             if (answers.material_name) {
    //                                 if (answers.material_type == 'camera') {
    //                                     let findCamera = this.cameras.find(i => i.name == answers.material_name);
    //                                     if (findCamera) {
    //                                         this.form.controls.cameras.setValue([findCamera._id]);
    //                                     }
    //                                 } else {
    //                                     let findDoc = this.docs.find(i => i.name == answers.material_name);
    //                                     if (findDoc) {
    //                                         this.form.controls.documents.setValue([findDoc._id]);
    //                                     }
    //                                 }
    //                                 // else if (answers.material_type == 'audio') {
    //                                 //     let docs = this.docs.filter((itm) => itm.type == 'audio')
    //                                 //     let findDoc = docs.find(i => i.name == answers.material_name);
    //                                 //     if (findDoc) {
    //                                 //         this.form.controls.audioControl.setValue([findDoc._id]);
    //                                 //     }
    //                                 // }
    //                                 // else if (answers.material_type == 'image') {
    //                                 //     let docs = this.docs.filter((itm) => itm.type == 'image')
    //                                 //     let findDoc = docs.find(i => i.name == answers.material_name);
    //                                 //     if (findDoc) {
    //                                 //         this.form.controls.imageControl.setValue([findDoc._id]);
    //                                 //     }
    //                                 // }
    //                                 // else if (answers.material_type == 'file') {
    //                                 //     let docs = this.docs.filter((itm) => itm.type == 'file')
    //                                 //     let findDoc = docs.find(i => i.name == answers.material_name);
    //                                 //     if (findDoc) {
    //                                 //         this.form.controls.fileControl.setValue([findDoc._id]);
    //                                 //     }
    //                                 // }
    //                                 // else if (answers.material_type == 'video') {
    //                                 //     let docs = this.docs.filter((itm) => itm.type == 'video')
    //                                 //     let findDoc = docs.find(i => i.name == answers.material_name);
    //                                 //     if (findDoc) {
    //                                 //         this.form.controls.videoControl.setValue([findDoc._id]);
    //                                 //     }
    //                                 // }
    //                             }
    //                             // setTimeout(() => {
    //                             if (this.form.controls.address.value) {
    //                                 this.timelineMap.searchByText(this.form.controls.address.value);
    //                             }
    //                             // }, 1000);
    //                         }
    //                     });
    //                 }
    //                 this.loader.display(false);
    //             });
    //         }
    //     });
    // }

    /** Enum options for threat_types field (falls back to threat_type metadata). */
    get threatTypesEnumForEdit(): any[] {
        const multi = this.metadata.get('threat_types');
        const single = this.metadata.get('threat_type');
        return multi?.enum?.length ? multi.enum : single?.enum || [];
    }

    private getInitialThreatTypesFromNote(): string[] {
        const n = this.data.note;
        if (!n) {
            return [];
        }
        if (Array.isArray(n.threat_types) && n.threat_types.length) {
            return [...n.threat_types];
        }
        if (n.threat_type) {
            return [n.threat_type];
        }
        return [];
    }

    private isThreatCreate(): boolean {
        return this.isThreatType() && !this.data.note?._id && this.data.subType === 'threat';
    }

    private isThreatEdit(): boolean {
        return this.isThreatType() && !!this.data.note?._id;
    }

    isThreatType(): boolean {
        return this.getPayloadType() == 'threat' || this.data.subType == 'threat' || this.mainNoteType == 'threat';
    }

    private getPayloadType(): string {
        if (this.data.subType == 'threat' || this.mainNoteType == 'threat' || this.data.note?.type == 'threat' || this.type == 'threat' || this.data.type == 'threat') {
            return 'threat';
        }
        if (this.data.note?.type) {
            return this.data.note.type;
        }
        return this.type || 'note';
    }

    private hasLocationAndAddress(): boolean {
        const hasLocation = !!this.noteLocation;
        const hasAddress = !!(this.form.controls.address.value || '').trim();
        return hasLocation && hasAddress;
    }

    private handleCameraSelectionForThreat(cameraIds: string[]): void {
        if (!this.isThreatType()) {
            return;
        }

        if (!Array.isArray(cameraIds) || cameraIds.length === 0) {
            return;
        }

        const firstCameraId = cameraIds[0];
        const camera = this.cameras.find((c: any) => c._id === firstCameraId);

        if (!camera || !camera.geolocation) {
            return;
        }
        let geoloc = JSON.parse(camera.geolocation);
        if (Number(geoloc?.lat) === 0 && Number(geoloc?.lng) === 0) {
            return;
        }
        this.timelineMap.mapSelectTrigger({ lat: geoloc.lat, lng: geoloc.lng }, true);
        // this.noteLocation = typeof camera.geolocation === 'string' ? camera.geolocation: JSON.stringify(camera.geolocation);
    }

    private applyThreatState(): void {
        if (!this.isThreatType()) {
            this.form?.controls?.threat_type?.clearValidators();
            this.form?.controls?.threat_type?.updateValueAndValidity({ emitEvent: false });
            this.form?.controls?.threat_types?.clearValidators();
            this.form?.controls?.threat_types?.updateValueAndValidity({ emitEvent: false });
            this.updateThreatCameraValidators();
            return;
        }
        this.type = 'threat';
        this.data.subType = 'threat';
        this.mainNoteType = 'threat';
        if (this.form?.controls?.address) {
            this.form.controls.address.setValidators([Validators.required]);
            this.form.controls.address.updateValueAndValidity({ emitEvent: false });
        }
        if (this.form?.controls?.threat_type) {
            this.form.controls.threat_type.clearValidators();
            if (this.isThreatCreate() && this.metadata.get('threat_type')) {
                this.form.controls.threat_type.setValidators([Validators.required]);
            }
            this.form.controls.threat_type.updateValueAndValidity({ emitEvent: false });
        }
        if (this.form?.controls?.threat_types) {
            this.form.controls.threat_types.clearValidators();
            const metaMulti = this.metadata.get('threat_types');
            const requireThreatTypes =
                this.isThreatEdit() &&
                this.threatTypesEnumForEdit?.length > 0 &&
                (metaMulti ? !metaMulti.nullable : true);
            if (requireThreatTypes) {
                this.form.controls.threat_types.setValidators([
                    (c) =>
                        Array.isArray(c.value) && c.value.length > 0
                            ? null
                            : { required: true },
                ]);
            }
            this.form.controls.threat_types.updateValueAndValidity({ emitEvent: false });
        }
        this.form?.controls?.investigators?.removeValidators([Validators.required]);
        this.form?.controls?.investigators?.updateValueAndValidity({ emitEvent: false });
        this.form?.controls?.investigatorGroups?.removeValidators([Validators.required]);
        this.form?.controls?.investigatorGroups?.updateValueAndValidity({ emitEvent: false });
        this.updateThreatCameraValidators();
    }

    /** Single selected id on threat create (`data.subType === 'threat'` and no `data.note._id`). */
    get threatCameraSingleId(): string | null {
        const v = this.form?.controls?.cameras?.value;
        if (!Array.isArray(v) || v.length === 0) {
            return null;
        }
        return v[0];
    }

    onThreatSingleCameraChange(cameraId: string | null): void {
        if (this.isReadOnlyTimelineNote()) {
            return;
        }
        if (this.data.subType !== 'threat' || this.data.note?._id) {
            return;
        }
        this.form.controls.cameras.setValue(cameraId ? [cameraId] : [], { emitEvent: true });
    }

    private updateThreatCameraValidators(): void {
        const ctrl = this.form?.controls?.cameras;
        if (!ctrl) {
            return;
        }
        ctrl.clearValidators();
        ctrl.updateValueAndValidity({ emitEvent: false });
    }
    openDispatch(dialogThreat: any): void {
        let threatObject = dialogThreat;
        if (threatObject && threatObject.case && threatObject.case._id) {
            threatObject['caseId'] = threatObject.case._id;
        }
        threatObject['geoLocation'] = threatObject.geolocation;
        threatObject['sourceType'] = threatObject.source_type;
        this.dialog.open(ThreatDispatchDialogComponent, {
            width: "50vw",
            disableClose: true,
            data: {
                threat: threatObject,
                // threatsMetaIds,
                threatTypes: this.threatTypes,
                showThreatManagementCenter: true,
                dummyThreat: true
            },
        }).afterClosed().subscribe((result) => {
            // console.log(result);
            if (result) {
                if (!result.dummyThreat) {
                    this.dialogRef.close(undefined);
                }
            }
        });
    }
}
